<template>
        <div class="bg-wrap">
            <div class="all">
                <div class="kv">
                </div>
                <div class="players-wrap">
                    <div  class = "player" :class="index<players.length-1?'borderbottom':''" v-for="(value,index) in players" v-bind:key="index">
                        <img :src="getHead(value)">
                        <label>{{value.name}}</label>
                        <div class="info">
                            <span :class="value.isSubmit==1?'light':'shadow'" @click="toSee(value.isSubmit,value.player_id)">{{msg1}}</span>
                            <span :class="value.isSubmit==1?'light':'shadow'" @click="gotoScreen(value.player_id,type)">{{msg2}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
    import {getPlayerRegAnswerStation,toScreen} from "@/assets/js/api";

    export default {
        data(){
            return{
                players:[1,2,3,4,5],
                msg1:"查看",
                msg2:"投屏",
                type:1,
            }
        },
        methods:{
            getHead(value){
                return (value.avatar!=null&&value.avatar!='')?value.avatar: require("@/assets/img/head.png");
            },
            async gotoScreen(playerId,type){
                const rest = await toScreen({playerId,type})
                this.$toast("----投屏成功---")
                console.log(rest)
            },
            toSee(isSubmit,playerId){
                if(isSubmit==0) return
                this.$router.push({path:"/screen",query:{playerId:playerId,type:this.type}})
            },
            toAnswerBtn(type){
                switch (type) {
                    case 1:
                        this.$router.push({path:"/hostReg"})
                        break
                    case 2:
                        this.$router.push({path:"/hostComp"})
                        break
                }
            },
            async toGetPlayerRegQuestion(){
                const res = await getPlayerRegAnswerStation({})
                console.log(res)
                if(res.data.success){
                    this.players = res.data.data
                    this.avatar = res.data.avatar
                }
            },
            initWebSocket: function () {
                console.log("---socket 初始化---")
                this.websock = new WebSocket("ws://server.iumed.com.cn/plus/one/websocket");
                // this.websock = new WebSocket("ws://192.168.31.230:9090/one/websocket");
                this.websock.onopen = this.websocketonopen;
                this.websock.onerror = this.websocketonerror;
                this.websock.onmessage = this.websocketonmessage;
                this.websock.onclose = this.websocketclose;
            },
            websocketonopen: function () {
                console.log("WebSocket连接成功");
            },
            websocketonerror: function (e) {
                console.log("WebSocket连接发生错误"+e.code);
            },
            websocketonmessage: function (e) {
                console.log("----signal coming----",e)
                this.toGetPlayerRegQuestion()
            },
            websocketclose: function (e) {
                console.log("connection closed (" + e.code + ")");
            }
        },
        mounted(){
            this.initWebSocket();
            this.toGetPlayerRegQuestion()
        }
    }
</script>

<style scoped lang="scss">
    .bg-wrap{
        width: 100%;
        /*max-width: 375px;*/
        height: 100vh;
        background: #FFF url("../../assets/img/answer_bg.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        display: flex;
        flex-flow: column;
    }
    .all{
        overflow: scroll;
    }
    .kv{
        width: 100%;
        height: 250px;
        background: #FFF url("../../assets/img/answer_kv.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        position: relative;
    }
    .players-wrap{
        /*flex-grow: 1;*/
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        align-items: start;
        justify-content: space-between;
    }
    .player{
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        width: 50%;
        height: 130px;
        border-right: #a9acb1 1px solid;
        box-sizing: border-box;
    }

    .borderbottom{
        border-bottom: #a9acb1 1px solid;
    }

    .player{
        img{
            width: 50px;
            height: 50px;
        }
        .info{
            margin-top: 10px;
            span{
                /*background: #4caf50;*/
                color: #FFF;
                font-size: 14px;
                padding: 2px 10px;
                margin: 0 5px;
                border-radius: 10px;
            }
        }
        label{
            margin-top: 10px;
            color: #FFF;
            font-size: 16px;
        }

    }
    .light{
        background: #4caf50;
    }
    .shadow{
        background: #a9acb1;
    }
    img{
        width: 42px;
        height: 42px;
        border-radius: 50%;
    }


</style>